import enCompanyAdaptation from './en';
import ruCompanyAdaptation from './ru';

export default {
  en: {
    ...enCompanyAdaptation,
  },
  ru: {
    ...ruCompanyAdaptation,
  },
};
